import React from 'react';

export default function CanvasRotateButton({
  onClick,
  image,
  title,
  rotateClass = '',
  caption,
}) {
  return (
    <div className="flex flex-col items-center">
      <button
        className="px-3 py-2 rounded-xl bg-lt-brown text-white shadow-sm hover:bg-primary transition"
        onClick={() => onClick?.()}
        title={title}
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/${image}.png`}
          alt={title}
          className={`h-[20px] w-[20px] ${rotateClass}`}
        />
      </button>
      <span className="mt-1 text-xs text-stone-700">{caption}</span>
    </div>
  );
}
